import React, { useState, useContext, useEffect } from "react";
import {
  fetchAffiliatedNetworkPractitioner,
  fetchData,
  reportInvalidInfo,
} from "../../data/Contentapi";
import { MyContext } from "../../globalContext";
import ErrorFallBackComponent from "../../utils/ErrorFallBackComponent";
import {
  IconButton,
  Box,
  CircularProgress,
  Link,
  Container,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { getConfig } from "./../../loadconfig";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHouseMedical,
  faStethoscope,
} from "@fortawesome/free-solid-svg-icons";
import ProviderDetailsDownload from "../downloads/ProviderDetailsPDF";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { useTranslation } from "react-i18next";
import EmailIcon from "@mui/icons-material/Email";
import CheckIcon from "@mui/icons-material/Check";

import moduleIcon from "../assets/module.png";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ErrorAuthComponent from "../../utils/ErrorAuthComponent";
import { commonPublishEvent } from "../../utils/PublishEventMethod";

import CloseIcon from "@mui/icons-material/Close";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { makeStyles } from "@mui/styles";
import TextField from "@mui/material/TextField";
import EmailPopup from "../Common/EmailPopup";
import DialogTable from "../Common/DialogTable";
import { useTelemedicine } from "../hooks/useTelemedicine";

const useStyles = makeStyles({
  topScrollPaper: {
    alignItems: "flex-start",
  },
  topPaperScrollBody: {
    verticalAlign: "top",
  },
});

const ViewFacilityDetails = () => {
  const { t } = useTranslation();
  const [details, setDetails] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [metaData, setMetaData] = useState([]);
  const [service, setService] = useState([]);
  const [comments, setComments] = useState("");
  const mycontext = useContext(MyContext);

  const {
    selectedForDetails,
    showDetailsResult,
    setShowDetailResultData,
    languageData,
    setSearchPageNumberData,
    searchPageNumber,
    jwtToken,
    setJwtTokenData,
    setRecaptchaTokenData,
    setSessionIdData,
    getSessionIdData
    
  } = useContext(MyContext);

  const [showPopupReport, setShowPopupReport] = useState(false);
  const [showPopupSuccessReport, setShowPopupSuccessReport] = useState(false);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [submitBtn, setSubmitBtn] = useState(true);
  const [charLength, setCharLength] = useState(250);
  const [checkboxState, setCheckboxState] = useState({
    name: false,
    address: false,
    phone: false,
    locationClosed: false,
  });

  let config = getConfig();

  const [showPopup, setShowPopup] = useState(false);
  const [affiliatedNetworkPopup, updateAffiliatedNetworkPopup] =
    useState(false);
  const [affiliatedNetworkData, updateAffiliatedNetworkData] = useState(null);

  const emailResultView = async () => {
    setShowPopup(true);
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const classes = useStyles();
  const telemedicineData = useTelemedicine();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const formatPhoneNumber = (value) => {
    // Remove all non-digit characters
    const cleaned = ("" + value).replace(/\D/g, "");

    // Match the cleaned number to the format xxx-xxx-xxxx
    const regex = /^(\d{3})(\d{3})(\d{4})$/;
    const match = regex.exec(cleaned);
    // Early return if no match is found
    if (!match) {
      return value;
    }

    // Format the matched number
    return `${match[1]}-${match[2]}-${match[3]}`;
  };

  useEffect(() => {
    const fetchProviderDetails = async (searchCriteria) => {
      setLoading(true);
      setError(false);
      searchCriteria["language"] = languageData;

      try {
        const data = await fetchData(
          config.NETWORK_DETAIL_URL,
          searchCriteria,
          mycontext
        );
        handleProviderData(data);
      } catch (e) {
        handleFetchError(e);
      } finally {
        setLoading(false);
      }
    };

    if (shouldFetchProviderDetails(showDetailsResult)) {
      fetchProviderDetails(selectedForDetails);
    }
  }, [showDetailsResult, languageData]);

  const handleProviderData = (data) => {
    setMetaData(data.meta);
    if (isAuthorizedStatus(data.meta)) {
      resetSession();
    }
    setDetails(data.details);
    setService(
      data?.details?.providerDetails?.facility?.facilityTypeList
        ?.facilityType[0]?.facilitySubTypeList?.facilitySubType[0]
        ?.facilityServiceList?.service
    );
  };

  const handleFetchError = (errorVal) => {
    console.error("Error fetching provider details:", errorVal);
    setError(true);
  };

  const isAuthorizedStatus = (meta) => {
    return meta && meta.statusCode === "A";
  };

  const resetSession = () => {
    setJwtTokenData("");
    setRecaptchaTokenData("");
    setSessionIdData(false);
  };

  const shouldFetchProviderDetails = (showDetailsResultVal) => {
    return showDetailsResultVal;
  };

  const handleBackClick = () => {
    setShowDetailResultData(false);
    setSearchPageNumberData(searchPageNumber);
  };

  const handleCloseReportInvalidInfo = () => {
    setShowPopupReport(false);
    setCheckboxState({
      name: false,
      address: false,
      phone: false,
      locationClosed: false,
    });
    setComments("");
    setSubmitBtn(true);
    setCharLength(250);
  };
  const handleCloseSuccessReportInvalidInfo = () => {
    setShowPopupSuccessReport(false);
  };

  const handleReportInvalidInformation = async () => {
    setShowPopupReport(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const handleSuccessReportInvalidInformation = async () => {
    setShowPopupSuccessReport(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleCommentChange = (event) => {
    const commentLength = event.target.value.length;

    if (isCommentTooLong(commentLength)) return;

    const charlen = 250 - commentLength;
    setCharLength(charlen);
    setComments(event.target.value);

    validation();
  };

  const isCommentTooLong = (length) => {
    return length > 250;
  };

  const handleChange = (event) => {
    const { name: nameVal, checked } = event.target;
    setCheckboxState({
      ...checkboxState,
      [nameVal]: checked,
    });

    setSelectedCheckboxes((prevSelected) =>
      updateSelectedCheckboxes(prevSelected, nameVal, checked)
    );

    setTimeout(() => {
      validation();
    }, 1000);
  };

  const updateSelectedCheckboxes = (prevSelected, nameVal, checked) => {
    if (!checked) return prevSelected;
    return [...prevSelected, nameVal];
  };

  const validation = () => {
    if (shouldEnableSubmit(selectedCheckboxes, comments)) {
      setSubmitBtn(false);
    }
  };

  const shouldEnableSubmit = (selectedCheckboxesVal, commentsVal) => {
    return selectedCheckboxesVal.length >= 1 && commentsVal !== "";
  };

  const { name, address, phone, locationClosed } = checkboxState;

  const handleSubmitReport = async () => {
    let mp3Id = "";
    let hcode = "";
    details?.alternateIDList?.alternateID?.map((mp) => {
      if (mp.alternateIDType == "MP3ID") {
        mp3Id = mp.alternateIDNumber;
      }
      if (mp.alternateIDType == "HCODE") {
        hcode = mp.alternateIDNumber;
      }
    });

    // providerType: selectedForDetails?.alternateIDType,
    let invalidReportData = {
      providerId: mp3Id,
      providerName: details?.providerDetails?.facility?.facilityName,
      providerType: details?.providerType,
      invalidInfoList: {
        invalidInfo: selectedCheckboxes,
      },
      comments: comments,
      credId: hcode,
    };
    let searchCriteria = selectedForDetails;

    try {
      const data = await reportInvalidInfo(
        config.REPORT_INVALID_INFO_URL,
        invalidReportData,
        mycontext
      );

      setMetaData(data.meta);

      if (isStatusCodeA(data?.meta)) {
        resetSession();
      }

      if (data?.meta?.statusCode === "C") {
        handleCloseReportInvalidInfo();
        handleSuccessReportInvalidInformation();
      }

      setLoading(false);
    } catch (e) {
      console.error("Error fetching provider details:", e);
    }

    let eventData = {
      Locale: languageData,
      "Provider ID": searchCriteria.alternateIDNumber,
      "Product Code": searchCriteria.alternateIDType,
      "View Type": "DirectoryView",
    };

    await commonPublishEvent(
      "Provider Details",
      eventData,
      jwtToken,
      getSessionIdData()
    );
  };

  const shouldRenderComponent = (metaDataVal) => {
    return metaDataVal?.statusCode !== "F" && metaDataVal?.statusCode !== "A";
  };

  const shouldShowErrorFallback = (errorVal, metaDataVal) => {
    return errorVal || metaDataVal?.statusCode === "F";
  };

  const isStatusCodeA = (metaDataVal) => {
    return metaDataVal?.statusCode === "A";
  };

  const hasFacilityDetails = (detailsVal) =>
    detailsVal?.providerDetails?.facility?.facilityName;

  const hasFacilitySubTypeName = (detailsVal) => {
    return detailsVal?.providerDetails?.facility?.facilityTypeList
      ?.facilityType[0]?.facilitySubTypeList?.facilitySubType[0]
      ?.facilitySubTypeName;
  };

  const shouldShowTelemedModalities = (facility) => {
    return (
      facility?.isTelemedicine === true &&
      facility?.telemedModalities !== null &&
      facility?.telemedModalities !== ""
    );
  };

  const popupHandler = (flag) => {
    updateAffiliatedNetworkPopup(flag);
    if (flag) {
      let hcode = "";
      details?.alternateIDList?.alternateID?.map((mp) => {
        if (mp.alternateIDType == "HCODE") {
          hcode = mp.alternateIDNumber;
        }
      });
      fetchAffiliatedNetworkPractitioner(
        config.AFFILIATED_NETWORK_PRACTITIONER_URL,
        { hcode: hcode, locale: languageData == "es" ? "ES" : "EN" },
        mycontext
      )
        .then((data) => {
          updateAffiliatedNetworkData(data?.hospitalBasedProvider);
        })
        .catch((e) => {
          console.error(e.message);
        });
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const facilityDetails = () => {
    if (hasFacilityDetails(details)) {
      return (
        <>
          <FontAwesomeIcon
            icon={faHouseMedical}
            size="xl"
            style={{
              color: "#007839",
              verticalAlign: "baseline",
              marginRight: "1rem",
            }}
          />
          <span className="details-heading">
            {details?.providerDetails?.facility?.facilityName}
          </span>
        </>
      );
    }
  };


  const getProviderTeleMedicineText = () =>{
    return details?.providerDetails?.facility?.isTelemedicine ? (
      <>
      {t("telemedicineYes")} 
      </>
    ) : (
      <> 
      {t("telemedicineNo")}
      </>
    )
  }
  



  const caregiverText = () => {
    return (
      details?.providerDetails?.facility?.isTelemedicine &&
      (details?.providerDetails?.facility?.telemedCaregiverAccess
        ? t("caregiverYes")
        : t("caregiverNo"))
    );
  };

  const isHandicapAccessible = (flag) => {
    let value = "";
    if (flag === "Y") value = t("yes");
    if (flag === "N") value = t("no");

    return (
      value && (
        <span className="details-subheader">
          {t("HandicapAccessible")}: {value}
        </span>
      )
    );
  };

  const renderTable = () => {
    if (isStatusCodeA(metaData)) {
      return <ErrorAuthComponent />;
    } else {
      return (
        <>
          <table
            width={"100%"}
            style={{ marginTop: "2rem" }}
            className="detail-provider-table1"
          >
            <tbody>
              <tr style={{ textAlign: "left" }}>
                <td colSpan={2}>{facilityDetails()}</td>
              </tr>

              <tr>
                <td colSpan={2} style={{ textAlign: "left" }}>
                  {hasFacilitySubTypeName(details) && (
                    <label className="left-align">
                      {details?.providerDetails?.facility?.facilityTypeList?.facilityType
                        .map((ft) =>
                          ft?.facilitySubTypeList?.facilitySubType
                            .map((fst) => fst?.facilitySubTypeName)
                            .join(", ")
                        )
                        .join(", ")}
                    </label>
                  )}
                </td>
              </tr>

              <tr>
                <td colSpan={2} style={{ textAlign: "left" }}>
                  <label className="left-align">
                    {getProviderTeleMedicineText()}
                    <br />
                    {shouldShowTelemedModalities(
                      details?.providerDetails?.facility
                    ) && (
                      <div className="ml-3">
                        ({details?.providerDetails?.facility?.telemedModalities}
                        )
                        <span onClick={handleClick}>
                          <img
                            src={moduleIcon}
                            alt="Telemedicine modalities"
                            style={{ cursor: "pointer" }}
                          />
                        </span>
                      </div>
                    )}
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      className="popup-menu"
                      MenuListProps={{
                        "aria-labelledby": "basic-button",
                      }}
                    >
                      <MenuItem onClick={handleClose} className="popup-item">
                        <p style={{ color: "#007839" }}>
                          {t("viewModality")}
                          &nbsp;
                          <a href={telemedicineData} style={{ color: "#007839" }}>
                            <b>{t("here")}</b>
                          </a>
                        </p>
                      </MenuItem>
                    </Menu>
                    <div className="ml-3">{caregiverText()}</div>
                  </label>
                </td>
              </tr>
            </tbody>
          </table>

          <div className="details-main">
            <div className="details-left">
              <div className="details-left-content">
                <div
                  style={{
                    fontSize: "20px",
                    lineHeight: "1.5",
                    fontWeight: "bold",
                  }}
                >
                  {t("providerDetails")}
                </div>
                {details?.providerDetails?.facility?.bedCount > 0 && (
                  <>
                    <div style={{ marginTop: "2rem" }}>
                      <span className="details-subheader">
                        {t("numberOfBeds")}
                      </span>
                      <br />
                      {details?.providerDetails?.facility?.bedCount}
                    </div>
                  </>
                )}

                {service?.[0]?.serviceName && (
                  <>
                    <div style={{ marginTop: "2rem" }}>
                      <span className="details-subheader">{t("services")}</span>
                    </div>
                    {service.map((serv, indexser) => (
                      <div key={indexser}>{serv?.serviceName}</div>
                    ))}
                  </>
                )}

                {details?.providerDetails?.facility?.facilityLicenseList?.facilityLicense?.map(
                  (lice, index) => (
                    <div key={index} style={{ marginTop: "2rem" }}>
                      <span className="details-subheader">{t("license")}:</span>
                      <br />
                      <div>
                        {lice?.licenseType}/{lice?.licenseNumber}
                      </div>
                    </div>
                  )
                )}

                {details?.providerDetails?.facility?.certificationList
                  ?.certification[0]?.certifyingAgency === "JCAHO" &&
                  details?.providerDetails?.facility?.certificationList
                    ?.certification[0]?.certificationStatus === "ACTIVE" && (
                    <div style={{ marginTop: "2rem" }}>
                      <span className="details-subheader">
                        {t("accreditation")}:
                      </span>
                      <br />
                      {t("jointCommission")}
                    </div>
                  )}

                {details?.providerDetails?.facility?.npi2 && (
                  <div style={{ marginTop: "2rem" }}>
                    <span className="details-subheader">{t("npi")}</span>
                    <br />
                    {details?.providerDetails?.facility?.npi2}
                  </div>
                )}
              </div>
            </div>

            <div className="details-right">
              <div className="details-right-content">
                <div className="details-location">{t("location")}</div>
                <div className="right-sub-content">
                  {details?.officeList?.office?.map((office, indexMain) => (
                    <div key={indexMain} className="box-end">
                      <div className="details-flexFac">
                        <div className="detailsLeft">
                          <div>
                            {office?.address?.domesticAddress?.addressLine1}
                          </div>
                          <div>
                            {office?.address?.domesticAddress?.city}
                            ,&nbsp;
                            {
                              office?.address?.domesticAddress?.state
                                ?.stateAbbreviation
                            }
                            &nbsp;
                            {office?.address?.domesticAddress?.zipcode}
                          </div>
                          {office?.phoneList?.phone.map((phoneVal, indexphone) => (
                            <div key={indexphone}>
                              <a
                                href={`tel:${phoneVal?.phoneNumber}`}
                                className="results-link"
                              >
                                {formatPhoneNumber(phoneVal?.phoneNumber)}
                              </a>
                            </div>
                          ))}
                          <div style={{ marginTop: "10px" }}>
                            <a
                              href={`${config.GOOGLEMAPLOCURL}${office?.address?.domesticAddress?.addressLine1},${office?.address?.domesticAddress?.addressLine2},${office?.address?.domesticAddress?.city}, ${office?.address?.domesticAddress?.state?.stateAbbreviation},${office?.address?.domesticAddress?.zipcode}`}
                              target="_blank"
                              rel="noreferrer"
                              className="results-link"
                            >
                              {t("mapLocation")}
                            </a>
                          </div>
                        </div>
                        <div className="detailsRight">
                          {office?.waitTimeList?.waitTime?.map(
                            (wait, indexWait) => (
                              <div
                                key={indexWait}
                                style={{ marginTop: "1rem" }}
                              >
                                <span className="details-subheader">
                                  {wait?.typeOfCare?.description}:
                                </span>
                                <span style={{ color: "#000" }}>
                                  {wait?.wait} {wait?.waitUnit}
                                </span>
                              </div>
                            )
                          )}
                        </div>
                      </div>
                      <div
                        style={{
                          marginTop: "2rem",
                          fontSize: "14px",
                          lineHeight: "1.5",
                        }}
                      >
                        {isHandicapAccessible(office?.isHandicapAccessible)}

                        {office?.ecpindicator && (
                          <div>
                            <span className="details-subheader">
                              {t("essentialCommunityProvider")}:{" "}
                            </span>
                            <span style={{ color: "#000" }}>
                              {t(office.ecpindicator === "Y" ? "yes" : "no")}
                            </span>
                          </div>
                        )}


                        {office?.telemedicine && (
                          <div>
                          <span className="details-subheader">
                            {t("telemedicineIndicator")}:{" "}
                          </span>
                          <span style={{ color: "#000" }}>
                            {t(office?.telemedicine)}
                          </span>
                        </div>
                          
                        )}

                        {office?.remotecaregiverliaison && (
                          <div>
                          <span className="details-subheader">
                            {t("remoteCareGiverLiaison")}:{" "}
                          </span>
                          <span style={{ color: "#000" }}>
                            {t(office?.remotecaregiverliaison)}
                          </span>
                        </div>
                          
                        )} 
                        
                        <div>{office?.officeTelemedModalitiesList?.officeTelemedModality?.length > 0 && (
                        <span className="details-subheader">
                            {t("Modalities")}:{" "}
                          </span>
                          )}
                        {office?.officeTelemedModalitiesList?.officeTelemedModality?.map((modality, indexMod)=>(                        
                          
                          <span style={{ color: "#000" }} key={indexMod}>
                            {t(modality?.code)}
                            {indexMod < office?.officeTelemedModalitiesList?.officeTelemedModality?.length - 1 ? ", " : ""}
                          </span>
                       
                        ))}
                         </div>
               
                      </div>
                      {details?.officeList?.office?.[0]?.address
                        ?.domesticAddress?.state?.stateAbbreviation ===
                        "TX" && (
                        <div style={{ marginTop: "2rem" }}>
                          <FontAwesomeIcon
                            icon={faStethoscope}
                            size="l"
                            style={{
                              color: "#007839",
                              verticalAlign: "baseline",
                              marginRight: "5px",
                            }}
                          />
                          <a
                            href="#"
                            className="view-practioner"
                            onClick={() => popupHandler(true)}
                          >
                            {t("viewAffiliated")}
                          </a>
                          <DialogTable
                            showPopup={affiliatedNetworkPopup}
                            closeBtnHanlder={() => popupHandler(false)}
                            popupTitle={t(
                              "affiliatedNetworkPractitionersLiisting"
                            )}
                            closeBtnText={t("closeBtn")}
                            noResultMessage={t(
                              "affiliatedNetworkPractitionersNoResults"
                            )}
                            tableData={affiliatedNetworkData}
                            tableHeadingList={[
                              t("providerName"),
                              t("specialtyype"),
                            ]}
                            valueToRenderKeyList={[
                              "providerName",
                              "specialtyype",
                            ]}
                          />
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </>
      );
    }
  };

  const renderComponent = () => {
    if (loading) {
      return (
        <Box alignItems="center">
          <CircularProgress data-testid="loading-circle" color="primary" />
        </Box>
      );
    } else {
      return shouldShowErrorFallback(error, metaData) ? (
        <ErrorFallBackComponent />
      ) : (
        renderTable()
      );
    }
  };

  return (
    <Container sx={{ width: "100%", marginY: "2%" }} fixed>
      <Box sx={{ width: "100%" }}>
        <div className="box-responsive">
          <div className="dflex-space">
            <div className="linkBoxResp width-50" style={{ textAlign: "left" }}>
              <KeyboardArrowLeftIcon
                style={{ verticalAlign: "middle", color: "green" }}
              />{" "}
              <Link
                href="#"
                style={{ fontWeight: "bold", fontSize: "1.2rem" }}
                onClick={handleBackClick}
              >
                {" "}
                {t(`back`)}
              </Link>
            </div>

            <div className="width-70">
              {shouldRenderComponent(metaData) && (
                <div className="dflex">
                  <div className="linkBoxResp width-33" style={{ marginRight: "30px" }}>
                    <CheckIcon
                      style={{ verticalAlign: "middle", color: "#007839" }}
                    />{" "}
                    <a
                      href="#"
                      className="results-link"
                      onClick={handleReportInvalidInformation}
                    >
                      {" "}
                      {t(`reportInvalidInfo`)}
                    </a>{" "}
                  </div>
                  &nbsp;&nbsp;
                  <div className="width-33" style={{ marginRight: "30px" }}>
                    <ProviderDetailsDownload />{" "}
                  </div>
                  &nbsp;&nbsp;
                  <div className="linkBoxResp width-25">
                    {" "}
                    <EmailIcon
                      style={{ verticalAlign: "middle", color: "#007839" }}
                    />{" "}
                    <a
                      href="#"
                      onClick={emailResultView}
                      className="results-link"
                    >
                      {" "}
                      {t(`emailresults`)}
                    </a>
                  </div>
                  <EmailPopup
                    setShowPopup={setShowPopup}
                    showPopup={showPopup}
                    pageType="detail"
                  />
                </div>
              )}
            </div>
          </div>
          {renderComponent()}
          <div className="reportInvalidInformationDiv">
            <Dialog
              className="nationalDialog"
              open={showPopupReport}
              onClose={() => setShowPopupReport(false)}
              aria-labelledby="view-national-providers-dialog"
              maxWidth="md"
              fullWidth
              sx={{
                "& .MuiDialog-root": {
                  overflowY: "scroll !important",
                },
                "& .MuiDialog-container": {
                  marginTop: "75rem",
                  marginBottom: "55rem",
                  height: "100vh !important",
                },
                "& .MuiDialog-paper": {
                  maxHeight: "max-content !important",
                  marginTop: "5rem",
                  overflowY: "visible",
                },
              }}
              classes={{
                scrollPaper: classes.topScrollPaper,
                paperScrollBody: classes.topPaperScrollBody,
              }}
            >
              <DialogTitle
                sx={{ fontWeight: "bold", position: "relative" }}
                id="view-national-providers-dialog"
              >
                <h4> {t(`reportInvalidInformation`)} </h4>
                <IconButton
                  edge="end"
                  color="green"
                  onClick={handleCloseReportInvalidInfo}
                  sx={{ position: "absolute", right: 8, top: 8 }}
                >
                  <CloseIcon sx={{ color: "green" }} />
                </IconButton>
              </DialogTitle>
              <DialogContent
                sx={{
                  paddingLeft: "25px",
                  paddingRight: "25px",
                }}
              >
                <div className="reportInvalidDiv">
                  <p> {t(`pleaseLetUsKnow`)}</p>
                  <p>
                    <span style={{ color: "#007839" }}>
                      <b>{details?.providerDetails?.facility?.facilityName}</b>
                    </span>{" "}
                    {t(`willBeContacted`)}
                  </p>

                  <p>
                    {" "}
                    <b>{t(`whatNeedsToBeCorrected`)}</b>{" "}
                  </p>

                  <div className="checkboxDiv">
                    <div className="checkleft">
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              size="small"
                              checked={name}
                              onChange={handleChange}
                              name="name"
                            />
                          }
                          label={t(`name`)}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              size="small"
                              checked={address}
                              onChange={handleChange}
                              name="address"
                            />
                          }
                          label={t(`address`)}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              size="small"
                              checked={phone}
                              onChange={handleChange}
                              name="phone"
                            />
                          }
                          label={t(`phone`)}
                        />
                      </FormGroup>
                    </div>

                    <div className="checkright">
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              size="small"
                              checked={locationClosed}
                              onChange={handleChange}
                              name="locationClosed"
                            />
                          }
                          label={t(`locationClosed`)}
                        />
                      </FormGroup>
                    </div>
                    <div className="clear"></div>
                  </div>

                  <div>
                    <TextField
                      fullWidth
                      id="outlined-multiline-static"
                      placeholder="Comments"
                      name="comments"
                      value={comments}
                      onChange={handleCommentChange}
                      multiline
                      rows={4}
                    />
                  </div>
                  <p className="numb">{charLength}/250</p>

                  <p>{t(`youMayAlsoLike`)}</p>
                  <p>
                    <b>
                      <a
                        href="mailto:msaprovidersearchdqrpt@claritev.com"
                        className="mail"
                      >
                        msaprovidersearchdqrpt@claritev.com
                      </a>
                    </b>
                  </p>
                  <p>
                    <b>
                      <a href="tel:866-814-7427" className="mail">
                        866-814-7427
                      </a>
                    </b>
                  </p>
                </div>
              </DialogContent>
              <DialogActions>
                <Button
                  variant="contained"
                  data-testid="closeBtn"
                  color="primary"
                  sx={{
                    textTransform: "initial",
                    borderRadius: "0px !important",
                  }}
                  onClick={handleCloseReportInvalidInfo}
                  className="font16"
                >
                  {t(`cancelBtn`)}
                </Button>

                <Button
                  variant="contained"
                  data-testid="closeBtn"
                  color="primary"
                  sx={{
                    textTransform: "initial",
                    borderRadius: "0px !important",
                  }}
                  onClick={handleSubmitReport}
                  className="font16"
                  disabled={submitBtn}
                >
                  {t(`submitBtn`)}
                </Button>
              </DialogActions>
            </Dialog>
          </div>

          <div className="reportSuccessDiv">
            <Dialog
              className="nationalDialog"
              open={showPopupSuccessReport}
              onClose={() => setShowPopupSuccessReport(false)}
              aria-labelledby="view-national-providers-success-dialog"
              maxWidth="md"
              fullWidth
              sx={{
                "& .MuiDialog-root": {
                  overflowY: "scroll !important",
                },
                "& .MuiDialog-container": {
                  marginTop: "75rem",
                  marginBottom: "55rem",
                  height: "100vh !important",
                },
                "& .MuiDialog-paper": {
                  maxHeight: "max-content !important",
                  marginTop: "5rem",
                  overflowY: "visible",
                },
              }}
              classes={{
                scrollPaper: classes.topScrollPaper,
                paperScrollBody: classes.topPaperScrollBody,
              }}
            >
              <DialogTitle
                sx={{ fontWeight: "bold", position: "relative" }}
                id="view-national-providers-dialog"
              >
                <h3> {t(`requestSent`)} </h3>
                <IconButton
                  edge="end"
                  color="green"
                  onClick={handleCloseSuccessReportInvalidInfo}
                  sx={{ position: "absolute", right: 8, top: 8 }}
                >
                  <CloseIcon sx={{ color: "green" }} />
                </IconButton>
              </DialogTitle>
              <DialogContent
                sx={{
                  paddingLeft: "25px",
                  paddingRight: "25px",
                }}
              >
                <div>{t(`reqSuccessMsg`)}</div>
              </DialogContent>
              <DialogActions>
                <Button
                  variant="contained"
                  data-testid="closeBtn"
                  color="primary"
                  sx={{
                    textTransform: "initial",
                    borderRadius: "0px !important",
                  }}
                  onClick={handleCloseSuccessReportInvalidInfo}
                  className="font16"
                >
                  {t(`closeBtn`)}
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        </div>
      </Box>
    </Container>
  );
};

export default ViewFacilityDetails;
